// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/app-" + chunkId + "." + {"770":"606e97f2","4024":"bd056b07","6207":"74d446c4","6916":"4f94350a"}[chunkId] + ".chunk.css";
};